import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'react-i18next'
import { customNoiticeModalBodyStyle } from '~/helper/const'
import Button from '~/components/Shared/Button'
import history from '~/services/history'
import * as S from './styled'

export default function ModalStripeAccountCreationSuccess({ handleCloseModal, showModal }) {
  const { t } = useTranslation()

  function closeModalAndRefreshRoute() {
    handleCloseModal()
    history.replace('/community')
  }

  return (
    <S.ModalCustom show={showModal} onHide={closeModalAndRefreshRoute}>
      <Modal.Header closeButton>
        <Modal.Title>
          <S.Title>{t('stripeAccountConnection')}</S.Title>
        </Modal.Title>
      </Modal.Header>
      <S.Container>
        <S.BannerImageContainer>
          <S.InvitationTextContainer>
            <S.InvitationText>{t('stripeAccountIsWell')}</S.InvitationText>
            <S.InvitationText>{t('stripeConnectedWithCommunity')}</S.InvitationText>
          </S.InvitationTextContainer>
        </S.BannerImageContainer>
      </S.Container>
      <Modal.Body style={customNoiticeModalBodyStyle}>
        <Container fluid>
          <S.TitleBodyCenter>{t('yourStripeAccountExists')}</S.TitleBodyCenter>
          <S.TitleBodyCenter>{t('stripeCheckDashboard')}</S.TitleBodyCenter>
          <S.TitleBodyCenter>{t('stripeYourDashboard')}</S.TitleBodyCenter>
          <S.TextContainer>
            <S.StartAgain onClick={() => window.open(`https://dashboard.stripe.com/`)}>
              www.dashboard.stripe.com
            </S.StartAgain>
          </S.TextContainer>
        </Container>
      </Modal.Body>
      <S.ModalFooter>
        <S.ModalFooterContainer>
          <Button
            margin
            uppercase
            text={t('done')}
            type="submit"
            action={closeModalAndRefreshRoute}
            width="110px"
            height="40px"
          />
        </S.ModalFooterContainer>
      </S.ModalFooter>
    </S.ModalCustom>
  )
}
